export default {
  data() {
    return {
      props: {
        'name': 'BlogAuthorCardComponent',
        'zIndex': 'auto',
        'paddingTop': '0px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px'
      },
      elements: [],
      internal_config: {
        'theme': '01',
        'width': '450px',
        'height': '100px',
        'zIndex': 'auto',
        'showDesktop': true,
        'showMobile': true,
        'paddingTop': '0px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        left: '0px',
        top: '0px',
        authorID: 0,
        authors: [],
        'backgroundColor': '#e6e6e6',
        'iconHoverColor': '#000',
        'emailColorIcon': '#363636',
        'facebookColorIcon': '#1877f2',
        'instagramColorIcon': '#d00174',
        'twitterColorIcon': '#1da1f2',
        'linkedinColorIcon': '#2867b2',
        'youtubeColorIcon': '#ff0000',
        'mediumColorIcon': '#12100e',
        'imageHeight': '100px',
        'titleStyle': {
          'family': 'Lato, sans-serif',
          'size': '25px',
          'sizeMobile': '15px',
          'color': '#464646',
          'align': 'left',
          'weight': '400',
          'style': 'initial',
          'stroke': 'none'
        },
        'subTitleStyle': {
          'family': 'Lato, sans-serif',
          'size': '12px',
          'sizeMobile': '15px',
          'color': '#464646',
          'align': 'left',
          'weight': '400',
          'style': 'initial',
          'stroke': 'none'
        },
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/editor/apps/Blog/AuthorCard/Model.js